// Convertit une URL YouTube / Vimeo en URL d'embed. Retourne null si non reconnue.
export function videoEmbed(url) {
  if (!url) return null;
  const u = String(url).trim();
  let m;
  if ((m = u.match(/(?:youtube\.com\/(?:watch\?.*v=|embed\/|shorts\/|live\/)|youtu\.be\/)([\w-]{6,})/)))
    return `https://www.youtube.com/embed/${m[1]}`;
  if ((m = u.match(/vimeo\.com\/(?:video\/|channels\/[\w]+\/|groups\/[\w]+\/videos\/)?(\d+)/)))
    return `https://player.vimeo.com/video/${m[1]}`;
  return null;
}
